import React from 'react';
import './circleviewcta.css'
import arrow from '../../assets/pic15.png'

const CircleCta = ({ onClick }) => {
    return ( 
        <button className='circle-cta'  onClick={onClick}>
            <img className='arrroww' src={arrow} alt='view'></img>
        </button>
     );
}
 
export default CircleCta;